export default class LayoutSqlUsuario {
  constructor(IdLayoutSql, IdUsuario, Descricao, Preferencias) {
    this.IdLayoutSql = IdLayoutSql;
    this.IdUsuario = IdUsuario;
    this.Descricao = Descricao;
    this.Preferencias = Preferencias;
  }
}